<template>
  <div>
    <work-schedule-time-select-date-header></work-schedule-time-select-date-header>
    <select-date-title-work-schedule-time
      :activeTab="activeTab"
    ></select-date-title-work-schedule-time>
    <select-date-content-work-schedule-time
      @selectDate="selectDate"
      ref="selectDateContentAppl"
    ></select-date-content-work-schedule-time>
  </div>
</template>
<script>
import WorkScheduleTimeSelectDateHeader from '@/components/application/form/WorkScheduleTimeSelectDateHeader.vue';
import SelectDateContentWorkScheduleTime from '@/components/application/form/SelectDateContentWorkScheduleTime.vue';
import SelectDateTitleWorkScheduleTime from '@/components/application/form/SelectDateTitleWorkScheduleTime.vue';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';

import { mapGetters } from 'vuex';
//import applCode from '@/const/applCodeConstants';

export default {
  mixins: [applCdMixin],
  components: {
    WorkScheduleTimeSelectDateHeader,
    SelectDateContentWorkScheduleTime,
    SelectDateTitleWorkScheduleTime,
  },
  data: () => ({
    activeTab: 'E',
    type: '',
    count: 0,
  }),
  computed: {
    ...mapGetters('ELA', ['GET_S_YMD', 'GET_E_YMD']),
    ...mapGetters(['GET_APPL_CD', 'GET_RETURNYMD', 'GET_APPL_TYPE']),
  },
  methods: {
    async selectDate() {
      this.OFF_APP_SPINNER();

      if (this.count === 0) {
        this.$refs.selectDateContentAppl.dates =
          this.$refs.selectDateContentAppl.dates[0];
      } else {
        this.$refs.selectDateContentAppl.dates =
          this.$refs.selectDateContentAppl.dates[1];
      }

      this.count++;

      this.$router.push(routerNames.WorkScheduleTime2);
    },
  },
  mounted() {
    this.$store.commit('SET_DAY_GUBUN_CD', '');
    this.$store.commit('SET_DAY_GUBUN_NM', '');
    this.$store.commit('SET_NOTE', '');
    this.$store.commit('SET_DATE', '');
    this.$store.commit('SET_PHONE_NO', '');
    this.$store.commit('SET_FILE_SEQ', '');

  },
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
};
</script>
<style></style>
